<template>
  <div class="as-mypages-layout">
    <v-app-bar
      app
      dark
      class="as-header mx-auto"
      height="64px"
    >
      <v-toolbar-title>
        <router-link :to="getLocalisedUrl('/')">
          <app-logo :show-tagline="true" />
        </router-link>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      
      <user-account-menu variant="light" show-language />

    </v-app-bar>
    
    <v-main class="mypage-view">
      <div class="my-pages-layout">
        <!-- Main Content Area -->
        <div class="main-content">
          <!-- Content Container -->
          <div class="content-container">

            <!-- Page Content -->
            <router-view :key="$route.fullPath" />

          </div>
        </div>
      </div>
    </v-main>

    <v-footer
      padless
      class="as-footer"
    >
      <div class="footer-content">
        <p class="footer-text">
          {{ $t('layout.mypages.footer.copyright', { year: new Date().getFullYear() }) }}
        </p>
        <p class="footer-text">
          <a href="mailto:info@asport.lv" class="footer-link">{{ $t('layout.mypages.footer.contact') }}</a> • 
          <a href="/terms" class="footer-link">{{ $t('layout.mypages.footer.terms') }}</a>
        </p>
      </div>
    </v-footer>
  </div>
</template>

<script>
import AppLogo from '@/components/Logo'
import UserAccountMenu from '@/components/private/layout/UserAccountMenu'
import urlUtil from '@/js/utils/urlUtil'

// Import mypages CSS
import '@/assets/css/mypages.css'

/** Layout used for authorized users before entering mypages - providing simple layout for pages before entering mypages */
export default {
  components: { AppLogo, UserAccountMenu },
  name: 'MyPagesSimpleLayout',
  created: function(){
    this.$store.dispatch('user/refreshUserData')
  },
  computed: {
    organizationName: function() {
      const organization = this.$store.getters['dashboard/activeOrganization']
      return organization && organization.name ? organization.name : null
    }
  },
  methods: {
    ...urlUtil,
    
    goToMyPages: function() {
      this.$router.push(this.getLocalisedMyPagesUrl())
    },
    logout: function(){
      this.$store.dispatch('user/logout')
    }
  }
};
</script>
<style>
/* Footer background to match Sidebar */
.v-footer .v-card {
  background: linear-gradient(180deg, var(--color-pallet-5) 0%, #2c3e50 100%) !important;
  color: white !important;
}

/* New Footer Styles for MyPages Layout - Scoped to avoid conflicts */
.as-mypages-layout .as-footer {
  background: #f5f5f5 !important;
  border-top: 1px solid #e0e0e0;
  padding: 16px !important;
  color: #666 !important;
}

.as-mypages-layout .footer-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.as-mypages-layout .footer-text {
  margin: 0 0 8px 0;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}

.as-mypages-layout .footer-text:last-child {
  margin-bottom: 0;
}

.as-mypages-layout .footer-link {
  color: var(--color-pallet-1);
  text-decoration: none;
  transition: color 0.2s ease;
  font-weight: 500;
}

.as-mypages-layout .footer-link:hover {
  color: #2e7d32;
  text-decoration: underline;
}

/* Mobile responsive footer */
@media (max-width: 768px) {
  .as-mypages-layout .as-footer {
    padding: 12px !important;
  }
  
  .as-mypages-layout .footer-content {
    max-width: 100%;
  }
  
  .as-mypages-layout .footer-text {
    font-size: 13px;
  }
}


.my-pages-layout {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.main-content {
  flex: 1;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.content-container {
  padding: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Mobile-specific improvements */
@media (max-width: 960px) {
  .content-container {
    padding: 16px;
  }
}

/* Extra small mobile devices */
@media (max-width: 480px) {
  .content-container {
    padding: 12px;
  }
}
</style>